import React from 'react';
import PropTypes from 'prop-types';
import {replaceTextToBold} from '../../../utils';
import {makeStyles} from "@material-ui/core";

const useStyles = makeStyles(theme => ({
    highlight: {
        '& b': {
            backgroundColor: '#CCC'
        }
    }
}));

export default function Highlight(props) {
    const { highlight, children } = props;
    const classes = useStyles();

    return <span className={classes.highlight} dangerouslySetInnerHTML={{__html: replaceTextToBold(children, highlight)}} />;
}

Highlight.propTypes = {
    highlight: PropTypes.string,
    children: PropTypes.string
};